<template>
  <v-card class="rounded-sm" color="primary">
    <v-card-text>
      <v-form v-model="trayectoriaLaboralForm" ref="form">
        <v-container>
          <v-row no-gutters>
            <v-col cols="12">
              <BaseInput class="mb-1" v-model="trayectoriaLaboral.empresa" validate-on-blur>
                <template v-slot:label>Empresa</template>
              </BaseInput>
            </v-col>
            <v-col cols="12">
              <BaseInput v-model="trayectoriaLaboral.puesto" label="Puesto que desempeñó"></BaseInput>
            </v-col>
            <v-col cols="12">
              <BaseInput v-model="trayectoriaLaboral.periodo" label="Periodo que desempeñó sus funciones"></BaseInput>
            </v-col>
            <v-col cols="12">
              <BaseInput v-model="trayectoriaLaboral.motivoConclusion" label="Motivo de Conclusión"></BaseInput>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions class="justify-center">
      <TextButton
        color="secondary"
        class="px-8"
        :disabled="!trayectoriaLaboralForm || loading"
        :loading="loading"
        @click="triggerSaveTrayectoriaLaboral"
      >
        Guardar
      </TextButton>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import BaseInput from '@/components/base/BaseInput.vue'
import TextButton from '../../../base/TextButton.vue'

export default {
  components: {
    BaseInput,
    TextButton,
  },

  props: {
    idPersonal: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      trayectoriaLaboralForm: false,
      loading: false,
      trayectoriaLaboral: {
        fk_idPersonal: this.idPersonal,
        empresa: '',
        puesto: '',
        periodo: '',
        motivoConclusion: '',
      },
    }
  },

  methods: {
    ...mapActions('dialog', ['closeDialog']),
    ...mapActions('trayectoriaLaboral', ['create', 'fetchByPersonal']),

    async triggerSaveTrayectoriaLaboral() {
      this.loading = true
      try {
        await this.create(this.trayectoriaLaboral)
        await this.fetchByPersonal(this.idPersonal)
        this.closeDialog()
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },

    resetForm() {
      if (this.$refs.form) this.$refs.form.resetValidation()
    },
  },
}
</script>
